import { render, staticRenderFns } from "./MenuWidget.vue?vue&type=template&id=6edd8f12"
import script from "./MenuWidget.vue?vue&type=script&lang=js"
export * from "./MenuWidget.vue?vue&type=script&lang=js"
import style0 from "./MenuWidget.vue?vue&type=style&index=0&id=6edd8f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports